import { Link } from 'react-router-dom';
import { footerGroups, siteName, siteTagline } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">{siteTagline}</p>
            <p className="mt-4 text-xs leading-relaxed text-background-300/60">
              本站为影视内容信息展示平台，影视资料与海报均为演示数据，不提供在线播放与下载服务。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300/60">
            © {new Date().getFullYear()} {siteName} · 演示站点
          </p>
          <p className="text-xs text-background-300/60">
            内容均为虚构示例，仅供界面展示与学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}